import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

function TermsNConditions() {
  return (
    <>
        <Navbar/>
         <div className='AboutUs-banner'>
        <h3>Terms and Conditions</h3>
        {/* <p>Customized ASIC & SOC Solutions with Optimized Cost</p> */}

        </div>
        <div className='terms'>

    <p><strong>Last Updated:</strong> [Insert Date]</p>

    <p>Welcome to <strong>Semicave Semiconductor</strong>. These Terms and Conditions ("Terms") govern your use of our website <a href="https://www.semicave.com">www.semicave.com</a> ("Website") and the services we offer.</p>

    <p>By accessing or using our Website, you agree to be bound by these Terms. If you do not agree with any part of these Terms, please do not use our Website.</p>

    <h2>1. Use of Website</h2>
    <p>You agree to use this Website only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the Website.</p>

    <h2>2. Intellectual Property</h2>
    <p>All content, trademarks, logos, graphics, images, text, and software on this Website are the intellectual property of Semicave Semiconductor or its content suppliers and are protected by applicable copyright and trademark laws.</p>
    <p>You may not reproduce, republish, distribute, or exploit any content from this Website without our prior written consent.</p>

    <h2>3. Services Disclaimer</h2>
    <p>While we strive to provide accurate and up-to-date information about our engineering solutions, we do not warrant that the content on the Website is complete, accurate, or error-free. All services and offerings are subject to availability and change without notice.</p>

    <h2>4. Limitation of Liability</h2>
    <p>Semicave Semiconductor shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of or inability to use the Website or any services offered through it.</p>

    <h2>5. External Links</h2>
    <p>This Website may contain links to third-party websites. We are not responsible for the content or practices of any linked site. Access to any external websites is at your own risk.</p>

    <h2>6. Privacy</h2>
    <p>Your use of the Website is also governed by our <a href="#">Privacy Policy</a>. Please review it to understand our practices regarding the collection and use of your personal information.</p>

    <h2>7. Changes to Terms</h2>
    <p>We may update these Terms from time to time. Changes will be posted on this page with a revised "Last Updated" date. Continued use of the Website constitutes your acceptance of the updated Terms.</p>

    <h2>8. Governing Law</h2>
    <p>These Terms shall be governed by and construed in accordance with the laws of [Your Country/State], without regard to its conflict of law provisions.</p>

    <h2>9. Contact Us</h2>
    <p>For questions regarding these Terms, you may contact us at:</p>
  
      <strong>Semicave Semiconductor</strong><br/><br/>
      Email: <a href="mailto:hr@semicave.com">hr@semicave.com</a><br/><br/>
      Phone: <a href="tel:+918147642693">+91 99029-78741</a><br/><br/>
      Address: BLOCK 11, Marathahalli - Sarjapur Outer Ring Rd, Kaverappa Layout, Kadubeesanahalli, Kadabeesanahalli, Bengaluru, Karnataka 560103
  
        </div>
        <Footer/>
    </>
  )
}

export default TermsNConditions